import { alpha, Box, Button, ButtonBase, FormControlLabel, styled, Switch, SxProps, Theme, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react'
import { filterType } from '../../redux-store/types/api-types';

type props = {
    options: Array<{
        label: string;
        value: number | string;
    }>,
    handleOptionChange: (value: string | number) => void
    value: string | number,
    containerStyle?: SxProps<Theme>,
    buttonStyle?: SxProps<Theme>
}

const SwitchSelection = (props: props) => {
    const {
        options,
        handleOptionChange = () => { return; },
        value,
        containerStyle = {},
        buttonStyle = {},
    } = props
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                bgcolor: theme.palette.grey.A100,
                borderRadius: '24px',
                padding: '6px',
                ...containerStyle
            }}
        >
            {options?.map((option) => (
                <ButtonBase
                    key={option.label}
                    disableRipple
                    onClick={() => handleOptionChange(option.value)}
                    sx={{
                        bgcolor: option.value == value ? theme.palette.common.white : 'transparent',
                        borderRadius: 6,
                        padding: '8px 16px',
                        transition: 'background-color 0.3s',
                        flex: 1,
                        textAlign: 'center',
                        ...buttonStyle,
                    }}
                >
                    <Typography
                        variant="body_500"
                        noWrap
                        color={option.value == value ? theme.palette.common.black : alpha(theme.palette.common.black, .60)}
                    >
                        {option?.label}
                    </Typography>
                </ButtonBase>
            ))}
        </Box>
    );
}

export default SwitchSelection